import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { BaseComponent } from '../../modules/shared/components/base.component';
import { NavigationEnd, Router } from '@angular/router';
import { AuthorizationService } from '../../modules/shared/service/authorization.service';
import { environment } from '../../../environments/environment';
import { ApplicationConfig } from '../../config/application.config';
import { TokenService } from '../../modules/shared/service/token.service';
import { Location } from '@angular/common';
import { AppsListComponent } from '@npm.chapps.com/chapps.common.angular.library';
import { of, timer } from 'rxjs';
import { LocalizationService } from '../../modules/shared/service/localization.service';
import { AccountSiteService } from '../../modules/shared/service/account-site.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent extends BaseComponent implements OnInit, AfterViewInit {

  @ViewChild(AppsListComponent) appsListComponent: AppsListComponent;
  public logoUrl: string;
  public userName: string;
  public userEmail: string;
  public isDashboardButtonActive: boolean;
  public isActionsButtonActive: boolean;
  public isIssuesButtonActive: boolean;
  public isInterventionTeamsButtonActive: boolean;
  public isContactsButtonActive: boolean;
  public isInterventionsButtonActive: boolean;
  public hideNavbar = true;
  public isLoginsButtonActive: boolean;
  public areSettingsActive: boolean;
  public zendeskUrl:string ;

  constructor(
    private router: Router,
    private authService: AuthorizationService,
    public config: ApplicationConfig,
    private tokenService: TokenService,
    private location: Location,
    private applicationConfig: ApplicationConfig,
    private localizationService: LocalizationService,
    private accountSiteService: AccountSiteService,
  ) {
    super();

    this.zendeskUrl = environment.zendeskUrl + '/' + this.localizationService.getLanguangeForZendesk();
  }

  ngOnInit() {
    this.userEmail = this.tokenService.getUsername();
    this.userName = `${this.tokenService.getFirstName()} ${this.tokenService.getLastName()}`;
    this.resetButtons();
    this.selectButtonDependingOfRoute(this.router.url);
    this.selectListItemDependingOnRoute(this.router.url);
    this.checkIfShouldHideNavbar(this.router.url);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.selectButtonDependingOfRoute(event.url);
        this.selectListItemDependingOnRoute(event.url);
        this.checkIfShouldHideNavbar(event.url);
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.appsListComponent) {
      this.appsListComponent.init(this.accountSiteService.getApplications());
    }
    // resize event needs to be called to fix the MDB nav bar component issue. Waiting for Angular 8 upgrade...
    timer(0).subscribe(() => window.dispatchEvent(new Event("resize")));
  }

  private checkIfShouldHideNavbar(url: string) {
    const isJobDetails = url.includes('jobs') && url.includes('details');
    const isJobEdit = url.includes('jobs') && url.includes('edit');
    const isJobAdd = url.includes('jobs') && url.includes('add');

    this.hideNavbar = isJobDetails || isJobEdit || isJobAdd;
  }

  public goBack() {
    this.location.back();
  }

  public showBackButton(): boolean {
    return this.isScreenNarrowEnoughForBackButton() && this.doShowBackButtonOnCurrentUrl();
  }

  public selectButtonDependingOfRoute(url: string) {
    this.isDashboardButtonActive = url.includes('dashboard');
    this.isActionsButtonActive = url.includes('jobs');
    this.isIssuesButtonActive = url.includes('issues');
    this.isInterventionTeamsButtonActive = url.includes('intervention-teams');
    this.isContactsButtonActive = url.includes('contacts');
    this.isInterventionsButtonActive = url.includes('interventions');
    this.isLoginsButtonActive = url.includes('logins');
    this.areSettingsActive = this.isContactsButtonActive
      || this.isLoginsButtonActive
      || this.isInterventionTeamsButtonActive;
  }

  public selectListItemDependingOnRoute(url: string) {
  }

  public logout() {
    this.authService.clearSession();
    window.location.href = environment.accountSiteUrl + 'signout?redirectUrl=' + window.location.href;
  }

  private resetButtons() {
    this.isDashboardButtonActive = false;
    this.isActionsButtonActive = false;
    this.isIssuesButtonActive = false;
    this.isInterventionTeamsButtonActive = false;
    this.isContactsButtonActive = false;
    this.isInterventionsButtonActive = false;
    this.isLoginsButtonActive = false;
    this.areSettingsActive = false;
  }

  private isScreenNarrowEnoughForBackButton(): boolean {
    return window.screen.width <= this.applicationConfig.MAX_RESOLUTION_TO_SHOW_BACK_BUTTON;
  }

  private doShowBackButtonOnCurrentUrl(): boolean {
    return this.applicationConfig.BACK_BUTTON_REGEXP_PAGES.some(r => this.router.url.match(r) != null);
  }
}
